<template>
  <div>
    <div class="banner">
      <p class="container">
        <span class="up">加入我们</span>
        <span class="down">JOIN US</span>
      </p>
    </div>
    <div class="path">
      <div class="container">当前位置： 首页 > 加入我们</div>
    </div>
    <section class="content container">
      <div class="intro">
        <h3>简介</h3>
        <span class="line"></span>
        <div class="tab-content">
          <div class="detail">
            <p>有 KPI 不如有目标，我们崇尚有自驱力的生活</p>
            <p>谈薪水不如自己定薪水，我们崇尚忘掉薪水无忧干活</p>
            <p>有假期不如有无限假期，我们崇尚工作生活两不误</p>
            <p>在大企业做螺丝钉还是来这儿自画人生</p>
            <p>你要相信自己的决定</p>
          </div>
          <img alt="bg" src="https://static.geekbang.org/infoq/5aa26e58ae18f.png?imageView2/0/">
        </div>
      </div>
      <div class="welfare intro">
        <h3>福利</h3>
        <span class="line"></span>
        <div class="tab-content">
          <div class="detail">
            <p><span>钞票在手：</span>固定工资、丰厚奖金（项目奖金＋优秀员工奖+人才推荐奖+年终奖金）。</p>
            <p><span>全面补助：</span>五险一金、补充医疗保险、年度体检。</p>
            <p><span>家庭&关爱：</span>带薪年假、节日慰问、结婚及生子福利、旅游、部门团建。</p>
            <p><span>学习=年轻：</span>“新生”入职培训、岗位胜任力培训、优秀员工出国交流。</p>
          </div>
        </div>
      </div>
      <div class="join">
        <h3>招聘岗位</h3>
        <span class="line"></span>
        <div class="tab-content">
          <div class="detail" v-for="(item, index) in recruitData" :key="index">
            <div class="title">{{item.title}}</div>
            <section>
              <div class="up">
                <p class="h4">岗位职责</p>
                <p v-for="(duty, idx) in item.dutys" :key="idx">{{'('+(idx+1)+') '+duty}}</p>
              </div>
              <div class="down">
                <p class="h4">任职要求</p>
                <p v-for="(need, idx) in item.needs" :key="idx">{{'('+(idx+1)+') '+need}}</p>
              </div>
              <div class="advantage down" v-if="item.advans">
                <p class="h4">加分项</p>
                <p v-for="(advan, idx) in item.advans" :key="idx" >{{'('+(idx+1)+') '+advan}}</p>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="will">
        <h3>在极客邦科技工作，你将会:</h3>
        <span class="line"></span>
        <p>1、和有相同价值观的队友，每天开开心心把事情做好；</p>
        <p>2、真正的弹性工作制（目前的 Team Leader 是弹性工作信仰者）；</p>
        <p>3、从0到1，亲手打造有趣有用的产品 (You Can You Up)；</p>
        <p>4、成为被自家产品服务的对象：免费学习IT课程；</p>
        <p>5、成为被自家产品服务的对象：零距离接触各种技术大神；</p>
        <p>6、成为被自家产品服务的对象：免费参加公司举办的各种技术大会：比如 QCon 和 ArchSummit。</p>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data () {
    return {
      recruitData: [{
        title: '技术编辑（AI人工智能方向）',
        dutys: [
          '跟踪前沿科技领域技术，挖掘具有价值的信息点；',
          '对既定材料进行编辑并成稿；',
          '撰写技术、产品、公司和行业相关文章；',
          '对技术人物进行访谈，输出人工智能领域对深度观点；',
          '报道学术界和业界人工智能相关会议，并撰写有影响力的内容。'
        ],
        needs: [
          '计算机、新闻学及编辑学相关专业；',
          '至少了解计算机技术1至2个领域的知识；',
          '具备AI人工智能领域工作经验者优先；',
          '具备英语读写、写作、沟通协调能力；',
          '外向、乐于分享及交流、渴望学习。'
        ]
      }, {
        title: '大会编辑（IT会议方向）',
        dutys: [
          '负责大会内容策划、包装工作，发掘优秀的联席主席、出品人及讲师（国际技术牛人，国内大牌公司技术牛人，技术社区贡献者）',
          '协助出品人做好议题（PPT）review并进行适度包装，为保证参会者体验和议题质量',
          '负责策划讲师培训、讲师欢迎晚宴、讲师见面会等活动',
          '从内容出发，调用公司内外资源，为大会推广提供策划。'
        ],
        needs: [
          '大学本科以上学历，计算机、新闻学专业优先；',
          '3年以上相关工作经历，对互联网、IT技术领域有浓厚兴趣；',
          '有过大型会议、活动策划执行经历，擅长拓展人脉资源；',
          '具备出色的交际能力，组织与策划能力优秀。'
        ]
      }, {
        title: '内容运营',
        dutys: [
          '负责极客时间 App 的内容运营，制定相关运营计划并落地，逐步完善运营规范和流程；',
          '负责极客时间 App 内容阶段性输出规划，有效引导用户，提升用户粘性及激活率；',
          '负责极客时间 App 付费内容的推广，并为最终结果负责；',
          '与产品、内容紧密配合，及时策划运营活动，获取用户流量并提升平台影响力。'
        ],
        needs: [
          '本科以上学历，有过运营类经验；',
          '对程序员群体感兴趣，对软件开发有一定了解；',
          '工作认真踏实，经验丰富，执行力强；',
          '热爱互联网产品，对知识服务感兴趣，学习意愿和能力强；',
          '较强的团队协作能力和沟通力，具有团队协作精神，抗压力强。'
        ]
      }]

      // {
      //   title: '资深PHP开发工程师',
      //   dutys: [
      //     '参与新产品系统的架构与搭建，输出稳定/高效的API给客户端调用；',
      //     '参与新产品管理系统的架构与搭建，完善运营管理功能；',
      //     '参与极客邦InfoQ/TGO/极客时间App等产品的新功能开发工作；',
      //     '参与极客邦运营平台及运营化工具的研发工作；',
      //     '参与需求分析、系统设计，数据模型设计等流程；',
      //     '保障代码质量以及项目进度。'
      //   ],
      //   needs: [
      //     '本科及以上学历，3年以上互联网／软件行业工作经验，具备在线教育相关工作经验者优先；',
      //     '熟悉Linux系统，精通Linux日常操作，能写基本的Shell脚本；',
      //     '熟悉TCP/HTTP/HTTPS基本协议栈,具备网间抓包,Debug的能力；',
      //     '熟悉PHP语言 ,对主流的应用框架(Yaf/Yii2/Laravel)有实战经验；',
      //     '熟悉Nginx+FPM模型, 了解Nginx的基本工作原理和适用场景,能够熟练配置并使用；',
      //     '熟悉Mysql/Redis等SQL/NOSQL工具的基本原理,能够熟练配置并使用；',
      //     '熟悉SQL语法, 了解索引的机制并合理使用 ,熟练的为SQL调优；',
      //     '良好的沟通表达能力、独立的分析/解决问题的能力；',
      //     '较强的责任和企业归属感。'
      //   ],
      //   advans: [
      //     '熟悉Linux系统工具的使用(如top,strace,perf,vmstat,sar,tcpdump),能够快速找出系统瓶颈并调优；',
      //     '熟悉Sed/Awk等Linux 文本工具的使用 ,结合shell构建复杂的系统工具；',
      //     '熟悉PHP常用的SPL库,并合理应用到日常开发中；',
      //     '熟悉PHP的多进程模型(PCNTL),熟悉PHP的协程模型,并合理应用到日常开发中；',
      //     '熟悉C语言 ,熟悉PHP扩展的开发,有实战经验；',
      //     '熟悉Go语言,有大规模并发服务的开发经验；',
      //     '熟悉Nginx(OpenResty)+Lua的开发模式,有大规模并发服务的开发经验。'
      //   ]
      // }, {
      //   title: 'Web前端工程师',
      //   dutys: [
      //     '负责极客时间官网和 App 相关的各种 Weex、Web、原生开发；',
      //     '负责公司相关运营活动开发；',
      //     '负责公司各种大会网站开发。'
      //   ],
      //   needs: [
      //     'HTML5、CSS3、JavaScript 基本功扎实，能编写兼容多种浏览器的前端页面代码；',
      //     '熟悉主流移动 Web 开发框架，使用 Vue / React 在工作中开发过若干项目；',
      //     '熟悉至少一种后端语言，如果是 Java / PHP / Node.js / Python 等那真是极好的；',
      //     '有 Weex 或者原生 App 开发经验优先，对 Weex 非常感兴趣也可以；',
      //     '丰富的移动端开发经验、熟练使用伸缩盒布局、熟悉微信 JS SDK；',
      //     '对产品的交互、体验有自己的见解，并乐于改善产品的用户体验；',
      //     '思路清晰、逻辑性强，具备较好的问题分析与解决能力，具备工程化的前端思维；',
      //     '三年及以上前端开发工作经验，精力充沛、最好是喜欢运动、爱好广泛；',
      //     '对「技术媒体」感兴趣，乐于「IT知识」传播与学习；',
      //     '必须要有工匠精神，认可分享的价值。'
      //   ]
      // }
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

.line
  display: block
  height: 1px
  background-color: #ccc
  margin: 20px 0
h3
  margin: 0 0 10px
  color: #3f3b3a
  font-size: 32px
  font-weight: 400
  line-height: 1em

.banner
  background: url('https://static.geekbang.org/infoq/5ac467a17cdf0.png?imageView2/0/w/800')
  height: 185px
  background-size: cover
  display: flex
  align-items: center
  p
    color: #fff
    display: flex
    flex-direction: column
    // align-items: center
    justify-content: center
    font-weight: 700
    +mobile
      align-items: center
    span:first-child
      font-size: 35px
      margin-bottom: 20px
      +mobile
        font-size: 28px
        margin-bottom: 10px
    span:last-child
      font-size: 20px
      +mobile
        font-size: 15px

.path
  background-color: #eee
  +mobile
    padding: 1rem

.content
  padding-top: 50px
  padding-left: 1rem
  padding-right: 1rem
  .intro
    margin-bottom: 30px
    .tab-content
      display: flex
      justify-content: space-between
      +mobile
        flex-direction: column-reverse
      .detail
        float: left
        font-size: 14px
        line-height: 38px
        margin-right: 50px
        p
          span
            font-weight: 700
        +mobile
          margin-right: 0
          text-align: justify
          margin-top: 15px
          font-size: 15px
          line-height: 25px
        &::before
          content: ''
          margin-bottom: 25px
          border-top: 1px solid #b5b5b6
  .welfare
    margin-bottom: 80px
    +mobile
      margin-bottom: 32px
    .tab-content
      .detail
        margin-top: 0

  .join
    .tab-content
      .detail
        .title
          color: #3f3b3a
          font-size: 24px
          margin: 16px 0
        section
          padding-bottom: 30px
          padding-left: 15px
          +mobile
            padding-bottom: 10px
          p
            color: #6a6c6b
            font-size: 14px
            line-height: 32px
            +mobile
              line-height: 28px
              font-size: 15px
            &.h4
              margin-bottom: 8px
              font-weight: 700
              font-size: 18px
          .down
            margin-top: 18px

div.will
  font-size: 14px
  margin: 40px 0
  .h4
    font-size: 18px
    font-weight: 700
    margin-bottom: 20px
  p
    color: #6a6c6b
    line-height: 32px
    font-size: 15px
</style>
